/// <amd-module name="VC/Common/Contracts/Constants" />

export namespace GitConstants {
    export const GitSecurityNamespaceId = "2e9eb7ed-3c0a-47d4-87c1-0ffdd275fd87";
    export const SecurableRoot = "repoV2/";
    export const GitToolName = "Git";
}

export const enum GitRepositoryPermissions {
    None = 0,
    Administer = 1,
    GenericRead = 2,
    GenericContribute = 4,
    ForcePush = 8,
    CreateBranch = 16,
    CreateTag = 32,
    ManageNote = 64,
    PolicyExempt = 128,
    CreateRepository = 256,
    DeleteRepository = 512,
    RenameRepository = 1024,
    EditPolicies = 2048,
    RemoveOthersLocks = 4096,
    ManagePermissions = 8192,
    PullRequestContribute = 16384,
    ProjectLevelPermissions = 32766,
    RepositoryLevelPermissions = 32510,
    BranchLevelPermissions = 14476,
    NonBranchRefLevelPermissions = 8200,
    BranchesRootLevelPermissions = 14492,
}

export const VersionControlArea = "VersionControl";
